import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    orderBy,
    limit,
    FieldValue
} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addDesignVariants,
    addSingleDesignVariant,
    updateDesignVariants,
    updateSingleDesignVariant,
    deleteSingleDesignVariant,
    getSingleDesignVariant,
    getSingleDesignVariantDetail,
    searchDesignVariants,
    getAllDesignVariants,
    getBatchDesignVariants,
    prepareDesignVariantsList
}

const collectionName = 'design-variants';
const collectionReference = collection(fireStoreDB, collectionName);

const addDesignVariants = (designVariants) => {
    return Promise.map(designVariants, async designVariant => {
        console.log('.');
        await addSingleDesignVariant(designVariant);
    });
}

const updateDesignVariants = (designVariants) => {
    return Promise.map(designVariants, async designVariant => {
        console.log('.');
        await updateSingleDesignVariant(designVariant);
    });
}

const addSingleDesignVariant = (designVariant) => {
    designVariant.createdAt = new Date();
    designVariant.updatedAt = designVariant.createdAt;

    return addDoc(collectionReference, designVariant);
}

const updateSingleDesignVariant = (designVariant) => {
    const documentReference = doc(fireStoreDB, collectionName, designVariant.id);
    designVariant.updatedAt = new Date();
    return setDoc(documentReference, designVariant, {merge: true});
}

const deleteSingleDesignVariant = (designVariant) => {
    const documentReference = doc(fireStoreDB, collectionName, designVariant.id);
    return deleteDoc(documentReference);
}

const getSingleDesignVariant = (designVariantId) => {
    const documentReference = doc(fireStoreDB, collectionName, designVariantId);
    return getDoc(documentReference);
}

const getSingleDesignVariantDetail = async (designVariantId) => {
    const documentReference = doc(fireStoreDB, collectionName, designVariantId);
    const designVariantDoc = await getDoc(documentReference);
    return prepareSingleDesignVariant(designVariantDoc);
}

const searchDesignVariants = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery,
        limit(20));

    const designVariantResult = await getDocs(searchQuery);
    return prepareDesignVariantsList(designVariantResult);
}

const getAllDesignVariants = async (designId) => {
    let searchQuery = query(collectionReference,
        where("designId", "==", designId));

    const designVariantResult = await getDocs(searchQuery);
    return prepareDesignVariantsList(designVariantResult);
}

const getBatchDesignVariants = async (designId, batchKey) => {
    let searchQuery = query(collectionReference,
        where("designId", "==", designId));

    searchQuery = query(searchQuery,
        where("batchKey", "==", batchKey));

    const designVariantResult = await getDocs(searchQuery);
    return prepareDesignVariantsList(designVariantResult);
}

const prepareDesignVariantsList = (designVariantResult) => {
    const designVariantsList = [];

    _.forEach(designVariantResult.docs, designVariantDoc => {
        designVariantsList.push(prepareSingleDesignVariant(designVariantDoc));
    });

    return designVariantsList;
}

const prepareSingleDesignVariant = (designVariantDoc) => {
    const designVariant = designVariantDoc.data();
    designVariant.id = designVariantDoc.id;
    return designVariant;
}
